import React from 'react';
import * as Yup from "yup";
import {Grid} from '@material-ui/core';
import {getMidnight} from 'data/utils/shortcuts';
import PriceDetails from '../../../flightEditor/components/ticketDetailsForm/components/priceDetails/PriceDetails';
import {
  ITicketDetailsWithTerms,
  ticketDetailsInitialValues,
  TicketDetailsInputs,
  ticketDetailsYupSchemaObject
} from 'gui/components/editors/flightEditor/components/ticketDetailsForm';
import {
  hotelDetailsInitialValues,
  HotelDetailsInputs,
  hotelDetailsYupSchemaObject,
  IHotelDetailsWithTerms
} from 'gui/components/editors/hotelEditor/components/hotelDetailsForm';
import AbstractProductDetailsForm
  from 'gui/components/editors/commons/editor/components/abstractProductDetailsForm';
import Conditions
  from 'gui/components/editors/commons/editor/components/abstractProductDetailsForm/components/conditions';
import objectArrayTools from 'object-arrarify';
import {discardObjectKeys} from 'data/utils/calculators';

interface IVacationDetailsFormProps {
  onSubmit: (formValues) => Promise<any>;
  ticketDetails: ITicketDetailsWithTerms;
  hotelDetails: IHotelDetailsWithTerms;
  setSubmitRef?: any;

  commonFormComponents?: any;
}

const vacationDetailsYupSchemaObject = Yup.object().noUnknown(true).concat(ticketDetailsYupSchemaObject).concat(hotelDetailsYupSchemaObject).shape({
  checkInDate:
    Yup.number()
      .when('originTimeOfLanding', (originTimeOfLanding, schema) => schema.test({
        test: checkInDate => getMidnight(checkInDate).getTime() >= getMidnight(originTimeOfLanding).getTime(),
        message: "זמן השהייה בבית מלון לא יכול להיות לפני זמן נחיתה ביעד"
      }))
      .required("יש לבחור זמן כניסה למלון").nullable(),
  checkOutDate: Yup.number().required("יש לבחור זמן יציאה מהמלון").nullable()
    .when('checkInDate', (checkInDate, schema) => schema.test({
      test: checkOutDate => getMidnight(checkOutDate).getTime() >= getMidnight(checkInDate).getTime(),
      message: "זמן יציאה מהמלון לא יכול להיות לפני זמן כניסה"
    }))
    .when('destinationTimeOfTakeOff', (destinationTimeOfTakeOff, schema) => schema.test({
      test: checkOutDate => getMidnight(checkOutDate).getTime() <= getMidnight(destinationTimeOfTakeOff).getTime(),
      message: "זמן יציאה מבית מלון לא יכול להיות אחרי טיסה חזור"
    })),
  totalHotelPaidPrice: Yup.number().strip(true),
  hotelToBePaidPrice: Yup.number().strip(true),
});

const VacationDetailsForm = (props: IVacationDetailsFormProps) => (<AbstractProductDetailsForm
  {...props}
  initialValues={{
    ...ticketDetailsInitialValues,
    ...hotelDetailsInitialValues,
    ...props.ticketDetails,
    ...props.hotelDetails,
    isRoundTripTicket: true,
    currentAirlineOneTicketPrice: (props.ticketDetails && props.ticketDetails.currentAirlineAllTicketsPrice && props.ticketDetails.ticketsAmount) ? (props.ticketDetails.currentAirlineAllTicketsPrice / props.ticketDetails.ticketsAmount) : undefined,
  }}
  yupSchemaObject={vacationDetailsYupSchemaObject}
  onSubmit={async (values) => {
    const v = objectArrayTools(values);
    await props
      .onSubmit({
        ticketDetails: discardObjectKeys({
          ...v.filter((value, key) => key in ticketDetailsInitialValues).toNormalObject(),
        }, key => key === 'currentAirlineOneTicketPrice'),
        hotelDetails: v.filter((value, key) => key in hotelDetailsInitialValues).toNormalObject(),
      });
  }}

  formComponents={({submitForm, submitCount, isSubmitting, setFieldValue, values, touched, errors}) => (
    <>
      <TicketDetailsInputs
        {...{submitForm, submitCount, isSubmitting, setFieldValue, values, touched, errors, forcedRoundTrip: true}}
      />
      <Grid item xs={12} style={{marginTop: 30}}/>
      <HotelDetailsInputs {...{submitForm, submitCount, isSubmitting, setFieldValue, values, touched, errors}}/>
      <Grid item xs={12} style={{marginTop: 30}}/>
      <PriceDetails values={values as any}/>
      <Grid item xs={12} style={{marginTop: 30}}/>
      <Conditions values={values}/>
    </>
  )}
/>);


VacationDetailsForm.defaultProps = {
  onSubmit: (formValues) => new Promise((resolve) => {
    
    setTimeout(resolve, 1000);
  }),
  ticketDetails: {},
  hotelDetails: {},
  setSubmitRef: () => {
  },
  commonFormComponents: () => null,
};

export default React.memo(VacationDetailsForm);
